import { createSelector } from '@reduxjs/toolkit';
import { denormalize } from 'normalizr';
import * as schemas from '../schemas';
import { list } from '~/tools/list';

const memoizedCompany = createSelector(
  (state) => state.entities.companies,
  (state) => state.entities.kioskAttributes,
  (state) => state.entities.employeeAttributes,
  (state, companyId) => companyId,
  (companies, kioskAttributes, employeeAttributes, companyId) => {
    const company = denormalize(companyId, schemas.company, {
      companies,
      kioskAttributes,
      employeeAttributes,
    });

    return company;
  },
);

/**
 * When converting to TypeScript:
 * import type { Company } from '~/interfaces/company.interface';
 * const selectCompany = (companyId: number) => (state: RootState): Company => memoizedCompany(state, companyId);
 */
const selectCompany = (companyId) => (state) => memoizedCompany(state, companyId);

const memoizedCompanies = createSelector(
  (state) => state.entities.companies,
  (companies) => {
    const companyList = Object.values(companies);

    return companyList.sort(list.byName);
  },
);

const selectCompanies = () => memoizedCompanies;

export const companySelectors = {
  selectCompany,
  selectCompanies,
};
